import { cn, ucFirst } from "@blocks/utils";
import { SVG } from "@wordpress/components";
import { createElement } from "@wordpress/element";
import parse from "html-react-parser";
import React from "react";
import icons from "./icons.json";

type Props = {
	name?: string;
	className?: string;
	size?: number;
} & JSX.IntrinsicElements["svg"];

const Icon: React.FC<Props> = (props) => {
	const { name, className = "", size = 24, ...otherProps } = props;

	if (!name) {
		return null;
	}

	const icon = name
		.split("-")
		.map((n, idx) => (0 === idx ? n : ucFirst(n)))
		.join("");

	if (!icons[icon]) {
		return null;
	}

	const appliedProps = {
		width: size,
		height: size,
		...(parse(icons[icon]) as React.ReactElement)?.props,
		className: cn("mzb-icon", className),
		...otherProps,
	};

	return createElement(SVG, appliedProps);
};

export default Icon;
